export class SqlTranspositions {
  public connection_string = 'default';
  public default_library: string;
  public libraries = [];
}
